import React, { memo } from 'react';
import { View } from 'react-native';
import { getBrowserIcon } from 'react-browser-icons';

export const IconBrowser = memo(({ size = 24, code }) => {
  return (
    <View>
      {getBrowserIcon({
        browser: code,
        style: { width: size },
      }) || <View style={{ width: size }} />}
    </View>
  );
});
